// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["scripts/gutenberg/blocks/container-swiper-wrapper/assets/style-container-swiper-wrapper"], () => (__webpack_require__("./src/scripts/gutenberg/blocks/container-swiper-wrapper/assets/container-swiper-wrapper.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
